import {
  DateChip,
  ItemDate,
  ItemDateCollapse,
  getDefaultIconByType,
  getDefaultTooltipByType,
} from '../../items';
import { useRef, useState } from 'react';

export const DateChipBadgeCell = ({
  dates,
  // setDateExpand,
  complete,
}: {
  dates: ItemDate[];
  // setDateExpand: Function;
  complete?: boolean;
}) => {
  const dateChipRef = useRef<HTMLDivElement>(null);
  const [dateExpand, setDateExpand] =
    useState<{
      dates: ItemDate[];
      open: boolean;
      anchorEl: any;
      complete?: boolean;
    }>();
  if (dates && dates.length > 0) {
    return (
      <>
        <DateChip
          ref={dateChipRef}
          badge={dates && dates.length > 0 ? dates.length - 1 : 0}
          onBadgeClick={() =>
            setDateExpand({
              open: true,
              dates: dates,
              anchorEl: dateChipRef.current,
              complete: complete,
            })
          }
          value={{
            start: dates?.[0]?.start ? new Date(dates?.[0]?.start) : undefined,
            end: dates?.[0]?.end ? new Date(dates?.[0]?.end) : undefined,
          }}
          complete={complete}
          // label={`${numDays}d Past Due`}
          tooltip={getDefaultTooltipByType(
            dates?.[0]?.type,
            !!dates?.[0]?.start,
            !!dates?.[0]?.end
          )}
          icon={getDefaultIconByType(dates?.[0]?.type)}
          disabled={true}
        />
        <ItemDateCollapse
          open={dateExpand?.open || false}
          close={() => setDateExpand(undefined)}
          dates={dateExpand?.dates || []}
          anchorEl={dateExpand?.anchorEl}
          complete={dateExpand?.complete}
        />
      </>
    );
  } else {
    return <div />;
  }
};
